import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import ManageSiteComponent from '../../components/ManageSiteComponent/ManageSiteComponent'

const ManageSite = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <ManageSiteComponent/>
                </div>
            </div>
        </div>
    )
}

export default ManageSite
